var selectedColorFilter = []; // global variable
let selectedAppFilter = [];
let selectedStockFilter = [];
   // alert('abcd');

if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSThemeConfig.custom.products_per_page,
			/* Optional */
			loadProductFirst: false,
			numberFilterTree: 2,
          filterTreeMobileStyle: 'style1',
		},
	};
}
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};


(function() {
	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    /************************** GET FILTER VALUES **************************/
  Filter.prototype.afterRender = function(data, eventType) {
  if (!data) data = this.data;
  if (!eventType) eventType = this.eventType;

  // Use delay to wait until Boost initializes filterParams
  setTimeout(function () {
    if (window.BCSfFilter && BCSfFilter.filterParams) {
      const selectedFilters = BCSfFilter.filterParams;

      console.log("Selected Filters (Delayed):", selectedFilters);

      // Example: Access vendor, tags, price
      const selectedVendors = selectedFilters.vendor || [];
      const selectedTags = selectedFilters.tags || [];
      const selectedPrice = selectedFilters.price || [];

      console.log("Vendors:", selectedVendors);
      console.log("Tags:", selectedTags);
      console.log("Price Range:", selectedPrice);

    } else {
      console.warn("Still not ready: BCSfFilter.filterParams is undefined");
    }
  }, 100); // 100ms delay usually works — you can increase to 300ms if needed
};
    /************************** END GET FILTER VALUES **************************/


  
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

		//Add class
		itemHtml = itemHtml.replace(/{{mobileRow}}/g, boostPFSConfig.custom.mobile_row);
		itemHtml = itemHtml.replace(/{{tabletRow}}/g, boostPFSConfig.custom.tablet_row);
		itemHtml = itemHtml.replace(/{{desktopRow}}/g, boostPFSConfig.custom.desktop_row );

		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImage(data, images));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}
		itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
		itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
		itemHtml = itemHtml.replace(/{{buildButtonSecond}}/g, buildButtonSecond());
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

		if (typeof Utils.compileShopifyProductVariables == 'function') {
			itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
		}

		if (typeof Utils.compileShopifyProductMetafield == 'function') {
			itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
		}
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildClass() {
		return boostPFSThemeConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
	}

	function buildClassHiz() {
		return boostPFSThemeConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
	}

	function buildButtonSecond() {
		return boostPFSThemeConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSThemeConfig.label.view_product + '</a>' : '';
	}

	function buildImage(data, images) {
		var htmlImg = '';
		if (!images) images = [];
		if (images.length == 0){
			images.push({
				src: boostPFSConfig.general.no_image_url,
				id: data.id,
				width: 480,
				height: 480
			});
		}
		if (images.length > 0) {
			htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
			var use_natural_size = false;
			var has_alternate_image = false;
			if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
				use_natural_size = true;
			}
			if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal) {
				has_alternate_image = true;
			}
			if (has_alternate_image) {
				htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
			}
			htmlImg += '">';

			var max_width = images[0].width;
			if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
			var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
			htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
			var aspect_ratio = images[0].width / images[0].height;
			if (use_natural_size) {
				htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
			}
			htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';

			if (has_alternate_image && images.length > 1) {
				var sizes = '200,300,400,600,800,900,1000,1200';
				var support_size = imageSize(sizes, images[1]);
				var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
				htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
			}

			var sizes_main = '200,400,600,700,800,900,1000,1200';
			var support_size = imageSize(sizes_main, images[0]);
			var thumbUrl_main = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '{width}x') : boostPFSConfig.general.no_image_url;
			htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl_main + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[0].id + '">';
			htmlImg += '<span class="Image__Loader"></span>';
			htmlImg += '<noscript>';
			htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '<img class="ProductItem__Image" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '</noscript>';
			htmlImg += '</div>';
			htmlImg += '</a>';
          
		}
		return htmlImg;
	}

	function imageSize(sizes, image) {
		if (image) {
			var desired_sizes = sizes.split(',');
			var supported_sizes = '';
			for (var k = 0; k < desired_sizes.length; k++) {
				var size = desired_sizes[k];
				var size_as_int = size * 1;
				if (image.width < size_as_int) { break; }
				supported_sizes = supported_sizes + size + ',';
			}

			if (supported_sizes == '') supported_sizes = image.width;

			if(!jQ.isNumeric(supported_sizes)) {
				supported_sizes = supported_sizes.split(',').join(',');
				supported_sizes = supported_sizes.substring(0,supported_sizes.lastIndexOf(','));
			}
			return supported_sizes;
		} else {
			return '';
		}
	}

	function buildPrice(data) {
		var html = '';
		var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
		var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
		html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
		if (onSale) {
			html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span> ';
			html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
		} else {
			if (priceVaries) {
				html += '<span class="ProductItem__Price Price Text--subdued">' + boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min)) + '</span>';
			} else {
				html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span>';
			}
		}
		html += '</div>';
		return html;
	}

	function buildLabels(data) {
		var html = '';
		var product_labels = '';
		if (boostPFSThemeConfig.custom.show_labels) {
			product_labels = '';
			var tags = data.tags;
			for (var k = 0; k < tags.length; k++) {
				var tag = tags[k];
				if (tag.indexOf('__label') != -1) {
				product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
				break;
				}
			}
			if (!soldOut) {
				if (onSale)
					product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sale + '</span>';
			} else {
				product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sold_out + '</span>';
			}

			if (product_labels != '') {
				html += '<div class="ProductItem__LabelList">';
				html += product_labels;
				html += '</div>';
			}
		}
		return html;
	}


 //  	function buildInfo(data, indx) {
	// 	var html = '';
	// 	if (boostPFSThemeConfig.custom.show_product_info) {
	// 		var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';

 //              // Check URL condition
 //              var isAllCollection = window.location.href.includes('collections/all') || window.location.href.includes('/search');
          
 //              if (boostPFSThemeConfig.custom.show_vendor && data.vendor) {
 //                html += '<p class="ProductItem__Vendor Heading">' +
 //                  (isAllCollection ? data.vendor.split(' ')[0] : data.vendor) +
 //                  '</p>';
 //              }
 //            // Check URL condition
          
	// 		html += '<div class="ProductItem__Info ' + infoClass + ' ">';
	// 		if (boostPFSThemeConfig.custom.show_vendor) {
	// 			html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
	// 		}

 //            // Check URL condition
          
 //            html += '<h2 class="ProductItem__Title Heading">';
 //            if (isAllCollection) {
 //              html += '<a href="{{itemUrl}}">' + (data.vendor ? data.vendor.split(' ')[0] + ' ' : '') + data.title + '</a>';
 //            } else {
 //              html += '<a href="{{itemUrl}}">' + data.title + '</a>';
 //            }
 //            html += '</h2>';

          
 //          // Check URL condition
 //              if (isAllCollection) {
                
 //              }
 //              else {
 //                   html += '<div class="ProductItem__Subtitle">';
 //            html += '<a href="{{itemUrl}}">' + data.metafields[0].value + '</a>';
 //            html += '</div>';
 //              }
          
	// 		// html += '<h2 class="ProductItem__Title Heading">';
	// 		// html += '<a href="{{itemUrl}}">' + data.vendor.split(' ')[0] + ' ' + data.title + '</a>';
	// 		// html += '</h2>';
 //            // html += '<div class="ProductItem__Subtitle">';
 //            // html += '<a href="{{itemUrl}}">' + data.metafields[0].value + '</a>';
 //            // html += '</div>';
	// 		html += '{{itemReviews}}';
	// 		html += buildPrice(data);
	// 		if (boostPFSThemeConfig.custom.show_color_swatch) {
	// 			html += buildSwatch(data, indx);
	// 		}
	// 		html += '</div>';
	// 	}

	// 	return html;
	// }



  
	function buildInfo(data, indx) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_product_info) {
			var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
			html += '<div class="ProductItem__Info ' + infoClass + ' ">';
			if (boostPFSThemeConfig.custom.show_vendor) {
				html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
			}

			html += '<h2 class="ProductItem__Title Heading">';
			html += '<a href="{{itemUrl}}">' + data.title + '</a>';
			html += '</h2>';
            html += '<div class="ProductItem__Subtitle">';
            html += '<a href="{{itemUrl}}">' + data.metafields[0].value + '</a>';
            html += '</div>';
			html += '{{itemReviews}}';
			html += buildPrice(data);
			if (boostPFSThemeConfig.custom.show_color_swatch) {
				html += buildSwatch(data, indx);
			}
			html += '</div>';
		}

		return html;
	}

    function m(t) {
      return (m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
          return typeof t
      }
      : function(t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      }
      )(t)
    }
  
    function mySlugify(t) {
      if (null == t || "object" == m(t))
          return "";
      if ("string" != typeof t) {
          if ("function" != typeof t.toString)
              return "";
          t = t.toString()
      }
      t = t.toLowerCase();
      for (var e = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;", n = 0, r = e.length; n < r; n++)
          t = t.replace(new RegExp(e.charAt(n),"g"), "aaaaaeeeeeiiiiiooooouuuuunc--_---".charAt(n));
      for (var i = "ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž".length, o = 0; o < i; o++)
          t = t.replace(new RegExp("ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž".charAt(o),"g"), "AaAaCcDdEeeIiNnOoOoRrSsTtUuuYyZz".charAt(o));
      for (var a = ["AE", "ae", "O", "o", "A", "a"], l = "ÆæØøÅå".length, s = 0; s < l; s++)
          t = t.replace(new RegExp("ÆæØøÅå".charAt(s),"g"), a[s]);
      return (t = t.replace(/'/g, "").replace(/"/g, "")).replace(/[\s\/]+/g, "-").replace(/[`~!@#$%^&*()|+\-=?;:'"’,.<>\{\}\[\]\\\/]/g, "-").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "")
    }




// code by Krys Dev
//  function buildSwatch(data, indx) {
//    // console.log("🔥 buildSwatch() called for:", data.handle || data.id);

//   var itemSwatchHtml = '';

//   if (boostPFSThemeConfig.custom.show_color_swatch) {
//     var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;

//     const selectedColorFilter = (BoostPFS.Globals.queryParams["pf_m_::custom::color_filter"] || []).map(c => {
//       const txt = document.createElement("textarea");
//       txt.innerHTML = c;
//       return txt.value.trim();
//     });
    
//     const selectedAppFilter = (
//       BoostPFS.Globals.queryParams["pf_m_::custom::application_filter"] || []
//     ).map(c => {
//       const txt = document.createElement("textarea");
//       txt.innerHTML = c;
//       return txt.value.trim();
//     });


// 	// stock filter
// 	const selectedStockFilter = (
// 		BoostPFS.Globals.queryParams["pf_m_::custom::limitedstock_filter"] || []
// 	).map(c => {
// 		const txt = document.createElement("textarea");
// 		txt.innerHTML = c;
// 		return txt.value.trim();
// 	});


//       const defaultVariantId = data.variants[0].id;  
//     // console.log("Data:", defaultVariantId);
//     // console.log("🎨 Selected Color Filter:", selectedColorFilter);
//     // console.log("🧴 Selected Application Filter:", selectedAppFilter);
//     // console.log("🧴 MAP OBJECT:", productMap);
//     // console.log("Data:", data);
    
//     data.options_with_values.forEach(function (option, index) {
//       var option_name = option.name.toLowerCase();
//       if (option_name.includes('color') || option_name.includes('colour') || option_name.includes('couleur')) {
//         var renderedColorValues = [];
//         itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
//         var i = 0;
//         let isFirstSelected = true;
// 		// console.log("NEW SERIES DATA:", data);
//         data.variants.forEach(function (variant) {
//           var temp = variant.merged_options.filter(function (obj) {
//             obj = obj.toLowerCase();
//             return obj.includes('color') || obj.includes('colour') || obj.includes('couleur');
//           });

//           if (!temp.length) return;
//           var value = temp[0].split(':')[1];
//           if (renderedColorValues.includes(value)) return;

//           renderedColorValues.push(value);

//           var size = '200,400,600,700,800,900,1000,1200';
//           var supported_sizes = imageSize(size, variant.image);
//           var checked = '';
//           var image_aspect_ratio = 1;

//           var imageInfo = data.images_info.find(function (imageOb) {
//             if (imageOb.src === variant.image) {
//               image_aspect_ratio = imageOb.width / imageOb.height;
//               return true;
//             }
//           }) || data.images_info[0] || {
//             src: boostPFSConfig.general.no_image_url,
//             id: variant.id,
//             width: 480,
//             height: 480
//           };

//           var dataImg = '" data-image-url="' + imageInfo.src +
//             '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="' + image_aspect_ratio +
//             '" data-image-id="' + imageInfo.id + '"';

//           var color_input_id = color_name + "-" + renderedColorValues.length;
//           var variant_price = variant.price || 0;
//           var variant_compare_at_price = variant.compare_at_price || 0;
//           var url_color = Utils.getFilePath(mySlugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
// 			// console.log("Handle:", data.handle);
// 			console.log("MAP:", productMap);
// 			// console.log("Merged Options:", data.variants.map(v => v.merged_options));
// 			// console.log("ProductMap Match:", productMap.find(obj => obj.handle == data.handle));
//           const productObj = productMap.find(obj => obj.handle == data.handle);
// 		  if (productObj) {
// 			// console.log(productObj);
//           const variantObj = productObj.vars;
//           const variantColorObj = variantObj.find(obj => obj.id == variant.id);
//           let rawColorFilter = (variantColorObj && variantColorObj.color_filter) || "";

//           const variantFilterObj = variantObj.find(obj => obj.id == variant.id);
//           let rawAppFilter = (variantFilterObj && variantFilterObj.app_filter) || "";
// 		  let rawStockFilter = (variantFilterObj && variantFilterObj.stock_filter) || "";

// 				// Skip swatch if stock metafield empty
// 				// if (
// 				// !rawStockFilter ||
// 				// rawStockFilter === "[]" ||
// 				// rawStockFilter.length === 0
// 				// ) {
// 				// return;
// 				// }

//               // COLOR FILTER 
//               if (typeof rawColorFilter === 'string') {
//                 rawColorFilter = rawColorFilter.replace(/^.*?\[/, '[');
//                 const txt = document.createElement("textarea");
//                 txt.innerHTML = rawColorFilter;
//                 rawColorFilter = txt.value;
//                 try {
//                   rawColorFilter = JSON.parse(rawColorFilter);
//                 } catch {
//                   rawColorFilter = [];
//                 }
//               }
//               if (!Array.isArray(rawColorFilter)) rawColorFilter = [];
    
//               const variantColorFilter = rawColorFilter.map(c => {
//                 const txt = document.createElement("textarea");
//                 txt.innerHTML = c;
//                 return txt.value.trim();
//               });

//               // APP FILTER
//               if (typeof rawAppFilter === 'string') {
//                 rawAppFilter = rawAppFilter.replace(/^.*?\[/, '[');
//                 const txt = document.createElement("textarea");
//                 txt.innerHTML = rawAppFilter;
//                 rawAppFilter = txt.value;
//                 try {
//                   rawAppFilter = JSON.parse(rawAppFilter);
//                 } catch {
//                   rawAppFilter = [];
//                 }
//               }
//               if (!Array.isArray(rawAppFilter)) rawAppFilter = [];
              
//               const variantAppFilter = rawAppFilter.map(c => {
//                 const txt = document.createElement("textarea");
//                 txt.innerHTML = c;
//                 return txt.value.trim();
//               });
    

// 			  // STOCK FILTER
// 				if (typeof rawStockFilter === 'string') {
// 					rawStockFilter = rawStockFilter.replace(/^.*?\[/, '[');
// 					const txt = document.createElement("textarea");
// 					txt.innerHTML = rawStockFilter;
// 					rawStockFilter = txt.value;
// 					try { rawStockFilter = JSON.parse(rawStockFilter); }
// 					catch { rawStockFilter = []; }
// 				}
// 				if (!Array.isArray(rawStockFilter)) rawStockFilter = [];
// 				const variantStockFilter = rawStockFilter.map(c => {
// 					const txt = document.createElement("textarea");
// 					txt.innerHTML = c;
// 					return txt.value.trim();
// 				});
// 				// ✅ STOCK - INDEPENDENT CHECK
// 				// Agar stock filter select hai:
// 				// - Variant ka metafield match kare toh dikhao
// 				// - Metafield empty ya match nahi = hide
// 				if (selectedStockFilter.length > 0) {
// 					const stockMatch = variantStockFilter.some(stock =>
// 					selectedStockFilter.includes(stock)
// 					);
// 					if (!stockMatch) return; // ← match nahi = skip
// 				}

//             //   console.log(" Selected Color Filter:", variantColorFilter);
//             //   console.log(" Selected Application Filter:", variantAppFilter);
// 			//    console.log(" Selected Stock Filter:", variantStockFilter);
//               // const isMatch = !selectedColorFilter.length || variantColorFilter.some(color =>
//               //   selectedColorFilter.includes(color)
//               // );


//               const isColorMatch = !selectedColorFilter.length || variantColorFilter.some(color =>
//                     selectedColorFilter.includes(color)
//                   );
              
//               const isApplicationMatch = !selectedAppFilter.length || variantAppFilter.some(app =>
//                 selectedAppFilter.includes(app)
//               );

// 			// console.log(
// 			//   "Variant:", variant.id, 
// 			//   "| rawStockFilter:", variantFilterObj && variantFilterObj.stock_filter,
// 			//   "| variantStockFilter:", variantStockFilter,
// 			//   "| selectedStockFilter:", selectedStockFilter
// 			// );
// 			// 				const isStockMatch = !selectedStockFilter.length || variantStockFilter.some(stock =>
// 			// 					selectedStockFilter.includes(stock)
// 			// 				);


// 				// const isMatch = isColorMatch && isApplicationMatch && isStockMatch;
//               const isMatch = isColorMatch && isApplicationMatch;
// 			  let isStockOk = true;
//               // console.log ('color filter', selectedColorFilter);
//               if (isMatch && isStockOk) {
//                     const activeClass = isFirstSelected ? 'active' : '';
//                     checked = isFirstSelected ? 'checked="checked"' : '';
//                     itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
        
//                     itemSwatchHtml +=
//                       '<input class="ColorSwatch__Radio" type="radio" ' + checked +
//                       ' name="' + color_name +
//                       '" id="' + color_input_id +
//                       '" value="' + value +
//                       '" data-image-aspect-ratio="' + image_aspect_ratio + '"' +
//                       ' data-variant-price="' + variant_price +
//                       '" data-variant-compare-at-price="' + variant_compare_at_price +
//                       '" data-variant-url="' + Utils.buildProductItemUrl(data) +
//                       '?variant=' + variant.id +
//                       '#Image' + imageInfo.id + '"' +
//                       dataImg + ' aria-hidden="true">';
        
//                     itemSwatchHtml +=
//                       '<label class="ColorSwatch ColorSwatch--small ' + activeClass +
//                       '" for="' + color_input_id +
//                       '" style="background-color: ' + value.replace(/\s/g, '').toLowerCase() +
//                       '; background-image: url(' + url_color +
//                       ')" title="' + value +
//                       '" data-tooltip="' + value + '"></label>';
        
//                     itemSwatchHtml += '</div>';
         
//                           if (isFirstSelected) {
//                                        setTimeout(() => {
//                               document.querySelectorAll('.ProductItem').forEach(productItem => {
//                                 const activeSwatch = productItem.querySelector('.ColorSwatch.active');
//                                 if (activeSwatch) {
//                                   const input = activeSwatch.closest('.ProductItem__ColorSwatchItem').querySelector('input.ColorSwatch__Radio');
//                                   if (input && input.dataset.imageUrl) {
//                                     const productImageWrapper = productItem.querySelector('a.ProductItem__ImageWrapper');
//                                     const productImage = productImageWrapper.querySelector('img.ProductItem__Image');
                                    
//                                     // Remove existing swatch image if any
//                                     const existingSwatchImg = productImageWrapper.querySelector('.bc-sf-product-swatch-img');
//                                     if (existingSwatchImg) existingSwatchImg.remove();
                            
//                                     // Add new swatch image
//                                     const swatchImg = document.createElement('img');
//                                     swatchImg.className = 'bc-sf-product-swatch-img';
//                                     swatchImg.src = input.dataset.imageUrl;
//                                     productImageWrapper.querySelector('.AspectRatio').prepend(swatchImg);
                            
//                                     // Hide default lazy-loaded image
//                                     if (productImage) {
//                                       productImage.style.display = 'none';
//                                     }
                            
//                                     // Update variant URL on image click
//                                     productImageWrapper.setAttribute('href', input.dataset.variantUrl);
//                                   }
//                                 }
//                               });
//                             }, 300); 
        
//                             isFirstSelected = false;
//                           }
//                   // console.log ('CHECK VALUE', variantColorObj);
				  
//             }
// 		  }
		  
        
//           i++;
//         });

//         itemSwatchHtml += '</div>';
//       }
      
//     });
//   }

//   return itemSwatchHtml;
// }

function buildSwatch(data, indx) {
  var itemSwatchHtml = '';

  if (boostPFSThemeConfig.custom.show_color_swatch) {
    var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;

    const selectedColorFilter = (BoostPFS.Globals.queryParams["pf_m_::custom::color_filter"] || []).map(c => {
      const txt = document.createElement("textarea");
      txt.innerHTML = c;
      return txt.value.trim();
    });
    
    const selectedAppFilter = (
      BoostPFS.Globals.queryParams["pf_m_::custom::application_filter"] || []
    ).map(c => {
      const txt = document.createElement("textarea");
      txt.innerHTML = c;
      return txt.value.trim();
    });

    const selectedStockFilter = (
      BoostPFS.Globals.queryParams["pf_m_::custom::limitedstock_filter"] || []
    ).map(c => {
      const txt = document.createElement("textarea");
      txt.innerHTML = c;
      return txt.value.trim();
    });

    const defaultVariantId = data.variants[0].id;  
    
    data.options_with_values.forEach(function (option, index) {
      var option_name = option.name.toLowerCase();
      if (option_name.includes('color') || option_name.includes('colour') || option_name.includes('couleur')) {
        var renderedColorValues = [];
        itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
        var i = 0;
        let isFirstSelected = true;

        data.variants.forEach(function (variant) {
          var temp = variant.merged_options.filter(function (obj) {
            obj = obj.toLowerCase();
            return obj.includes('color') || obj.includes('colour') || obj.includes('couleur');
          });

          if (!temp.length) return;
          var value = temp[0].split(':')[1];

          // ✅ DUPLICATE CHECK - pehle
          if (renderedColorValues.includes(value)) return;

          var size = '200,400,600,700,800,900,1000,1200';
          var supported_sizes = imageSize(size, variant.image);
          var checked = '';
          var image_aspect_ratio = 1;

          var imageInfo = data.images_info.find(function (imageOb) {
            if (imageOb.src === variant.image) {
              image_aspect_ratio = imageOb.width / imageOb.height;
              return true;
            }
          }) || data.images_info[0] || {
            src: boostPFSConfig.general.no_image_url,
            id: variant.id,
            width: 480,
            height: 480
          };

          var dataImg = '" data-image-url="' + imageInfo.src +
            '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="' + image_aspect_ratio +
            '" data-image-id="' + imageInfo.id + '"';

          var color_input_id = color_name + "-" + (renderedColorValues.length + 1);
          var variant_price = variant.price || 0;
          var variant_compare_at_price = variant.compare_at_price || 0;
          var url_color = Utils.getFilePath(mySlugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));

          const productObj = productMap.find(obj => obj.handle == data.handle);

          if (productObj) {
            const variantObj = productObj.vars;
            const variantColorObj = variantObj.find(obj => obj.id == variant.id);
            const variantFilterObj = variantObj.find(obj => obj.id == variant.id);

            let rawColorFilter = (variantColorObj && variantColorObj.color_filter) || "";
            let rawAppFilter = (variantFilterObj && variantFilterObj.app_filter) || "";
            let rawStockFilter = (variantFilterObj && variantFilterObj.stock_filter) || "";


			// ✅ DEBUG - YE ADD KARO
			// console.log(
			//   "Variant ID:", variant.id,
			//   "| stock_filter raw:", variantFilterObj && variantFilterObj.stock_filter,
			//   "| selectedStockFilter:", selectedStockFilter
			// );
			// console.log("ALL QUERY PARAMS:", BoostPFS.Globals.queryParams);
			// console.log("URL:", window.location.search);

            // COLOR FILTER PARSE
            if (typeof rawColorFilter === 'string') {
              rawColorFilter = rawColorFilter.replace(/^.*?\[/, '[');
              const txt = document.createElement("textarea");
              txt.innerHTML = rawColorFilter;
              rawColorFilter = txt.value;
              try { rawColorFilter = JSON.parse(rawColorFilter); } catch { rawColorFilter = []; }
            }
            if (!Array.isArray(rawColorFilter)) rawColorFilter = [];
            const variantColorFilter = rawColorFilter.map(c => {
              const txt = document.createElement("textarea");
              txt.innerHTML = c;
              return txt.value.trim();
            });

            // APP FILTER PARSE
            if (typeof rawAppFilter === 'string') {
              rawAppFilter = rawAppFilter.replace(/^.*?\[/, '[');
              const txt = document.createElement("textarea");
              txt.innerHTML = rawAppFilter;
              rawAppFilter = txt.value;
              try { rawAppFilter = JSON.parse(rawAppFilter); } catch { rawAppFilter = []; }
            }
            if (!Array.isArray(rawAppFilter)) rawAppFilter = [];
            const variantAppFilter = rawAppFilter.map(c => {
              const txt = document.createElement("textarea");
              txt.innerHTML = c;
              return txt.value.trim();
            });

            // STOCK FILTER PARSE
            if (typeof rawStockFilter === 'string') {
              rawStockFilter = rawStockFilter.replace(/^.*?\[/, '[');
              const txt = document.createElement("textarea");
              txt.innerHTML = rawStockFilter;
              rawStockFilter = txt.value;
              try { rawStockFilter = JSON.parse(rawStockFilter); } catch { rawStockFilter = []; }
            }
            if (!Array.isArray(rawStockFilter)) rawStockFilter = [];
            const variantStockFilter = rawStockFilter.map(c => {
              const txt = document.createElement("textarea");
              txt.innerHTML = c;
              return txt.value.trim();
            });

            // ✅ STOCK 
            // if (selectedStockFilter.length > 0) {
            //   const stockMatch = variantStockFilter.some(stock =>
            //     selectedStockFilter.includes(stock)
            //   );
            //   if (!stockMatch) return; // stock match nahi - skip, renderedColorValues mein add bhi nahi
            // }

			// ✅ STOCK - pehle define karo bahar
			const stockMatch = selectedStockFilter.length === 0 || variantStockFilter.some(stock =>
			selectedStockFilter.includes(stock)
			);

            //  COLOR + APP 
            const isColorMatch = !selectedColorFilter.length || variantColorFilter.some(color =>
              selectedColorFilter.includes(color)
            );

            const isApplicationMatch = !selectedAppFilter.length || variantAppFilter.some(app =>
              selectedAppFilter.includes(app)
            );
			// console.log("=== VARIANT CHECK ===");
			// console.log("variant value:", value);
			// console.log("selectedColorFilter:", JSON.stringify(selectedColorFilter));
			// console.log("selectedStockFilter:", JSON.stringify(selectedStockFilter));
			// console.log("variantColorFilter:", JSON.stringify(variantColorFilter));
			// console.log("variantStockFilter:", JSON.stringify(variantStockFilter));
			// console.log("isColorMatch:", isColorMatch);
			// console.log("stockMatch:", stockMatch);
            const isMatch = isColorMatch && isApplicationMatch && stockMatch;


			
            if (isMatch) {
              // ✅ SIRF YAHAN push karo - sab checks pass hone ke baad
              renderedColorValues.push(value);

              const activeClass = isFirstSelected ? 'active' : '';
              checked = isFirstSelected ? 'checked="checked"' : '';
              itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
  
              itemSwatchHtml +=
                '<input class="ColorSwatch__Radio" type="radio" ' + checked +
                ' name="' + color_name +
                '" id="' + color_input_id +
                '" value="' + value +
                '" data-image-aspect-ratio="' + image_aspect_ratio + '"' +
                ' data-variant-price="' + variant_price +
                '" data-variant-compare-at-price="' + variant_compare_at_price +
                '" data-variant-url="' + Utils.buildProductItemUrl(data) +
                '?variant=' + variant.id +
                '#Image' + imageInfo.id + '"' +
                dataImg + ' aria-hidden="true">';
  
              itemSwatchHtml +=
                '<label class="ColorSwatch ColorSwatch--small ' + activeClass +
                '" for="' + color_input_id +
                '" style="background-color: ' + value.replace(/\s/g, '').toLowerCase() +
                '; background-image: url(' + url_color +
                ')" title="' + value +
                '" data-tooltip="' + value + '"></label>';
  
              itemSwatchHtml += '</div>';

              if (isFirstSelected) {
                setTimeout(() => {
                  document.querySelectorAll('.ProductItem').forEach(productItem => {
                    const activeSwatch = productItem.querySelector('.ColorSwatch.active');
                    if (activeSwatch) {
                      const input = activeSwatch.closest('.ProductItem__ColorSwatchItem').querySelector('input.ColorSwatch__Radio');
                      if (input && input.dataset.imageUrl) {
                        const productImageWrapper = productItem.querySelector('a.ProductItem__ImageWrapper');
                        const productImage = productImageWrapper.querySelector('img.ProductItem__Image');
                        
                        const existingSwatchImg = productImageWrapper.querySelector('.bc-sf-product-swatch-img');
                        if (existingSwatchImg) existingSwatchImg.remove();
                
                        const swatchImg = document.createElement('img');
                        swatchImg.className = 'bc-sf-product-swatch-img';
                        swatchImg.src = input.dataset.imageUrl;
                        productImageWrapper.querySelector('.AspectRatio').prepend(swatchImg);
                
                        if (productImage) productImage.style.display = 'none';
                        productImageWrapper.setAttribute('href', input.dataset.variantUrl);
                      }
                    }
                  });
                }, 300); 

                isFirstSelected = false;
              }
            }
          }
          
          i++;
        });

        itemSwatchHtml += '</div>';
      }
    });
  }

  return itemSwatchHtml;
}
  
// function buildSwatch(data, indx) {
//   var itemSwatchHtml = '';

//   if (boostPFSThemeConfig.custom.show_color_swatch) {
//     var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;

//     const selectedColorFilter = (BoostPFS.Globals.queryParams["pf_m_::custom::color_filter"] || []).map(c => {
//       const txt = document.createElement("textarea");
//       txt.innerHTML = c;
//       return txt.value.trim();
//     });

//     const uniqueVariantColorMap = Array.from(
//       new Map(window.variantColorMap.map(obj => [obj.variant_title, obj])).values()
//     );

//     data.options_with_values.forEach(function (option) {
//       var option_name = option.name.toLowerCase();

//       if (option_name.includes('color') || option_name.includes('colour') || option_name.includes('couleur')) {
//         var renderedColorValues = [];
//         itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
//         var i = 0;
//         let isFirstMatch = true; 
        
//         data.variants.forEach(function (variant) {
//           var temp = variant.merged_options.filter(function (opt) {
//             opt = opt.toLowerCase();
//             return opt.includes('color') || opt.includes('colour') || opt.includes('couleur');
//           });

//           if (!temp.length) return;
//           var value = temp[0].split(':')[1];

//           if (!renderedColorValues.includes(value)) {
//             renderedColorValues.push(value);

//             var size = '200,400,600,700,800,900,1000,1200';
//             var supported_sizes = imageSize(size, variant.image);
//             var color_image = Utils.optimizeImage(variant.image);
//             var name_color = Utils.slugify(value) + '.png';
//             var checked = (i == 0) ? 'checked=checked' : '';

//             var imageInfo = data.images_info.find(function (img) {
//               return img.src == variant.image;
//             }) || data.images_info[0] || {
//               src: boostPFSConfig.general.no_image_url,
//               id: variant.id,
//               width: 480,
//               height: 480
//             };

//             var dataImg = imageInfo
//               ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"'
//               : '';

//             var color_input_id = color_name + "-" + renderedColorValues.length;
//             var variant_price = variant.price || 0;
//             var variant_compare_at_price = variant.compare_at_price || 0;
//             var url_color = Utils.getFilePath(mySlugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));

//             // const variantColorObj = uniqueVariantColorMap.find(obj => obj.id == variant.id);
//              const variantColorObj = variantColorMap.find(obj => obj.id == variant.id);
//             const variantTitle = (variantColorObj && variantColorObj.variant_title) || "";
//             let rawColorFilter = (variantColorObj && variantColorObj.color_filter) || "";

//             // ✅ Clean metafield like: COLOR [&quot;Blue&quot;,&quot;Green&quot;]
//             if (typeof rawColorFilter === 'string') {
//               // Remove label
//               rawColorFilter = rawColorFilter.replace(/^.*?\[/, '[');

//               // Decode HTML
//               const txt = document.createElement("textarea");
//               txt.innerHTML = rawColorFilter;
//               rawColorFilter = txt.value;

//               // Try parsing JSON
//               try {
//                 rawColorFilter = JSON.parse(rawColorFilter);
//               } catch (e) {
//                 rawColorFilter = [];
//               }
//             }

//             if (!Array.isArray(rawColorFilter)) rawColorFilter = [];

//             // Final clean filter
//             const variantColorFilter = rawColorFilter.map(c => {
//               const txt = document.createElement("textarea");
//               txt.innerHTML = c;
//               return txt.value.trim();
//             });

//             const isMatch = !selectedColorFilter.length || variantColorFilter.some(color =>
//               selectedColorFilter.includes(color)
//             );
            
            
//             if (isMatch) {
//                         const activeClass = isFirstMatch ? 'active' : '';
//                         const checked = isFirstMatch ? 'checked="checked"' : '';
//                         // const activeClass = isFirstMatch ? 'active' : '';
//                           itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
                          
//                           const isFilterApplied = selectedColorFilter.length > 0;
//                           const isVariantFiltered =
//                             variantColorFilter.length > 0 &&
//                             variantColorFilter.some(color => selectedColorFilter.includes(color));
                          
//                           // CASE 1: No filter → show default swatches for all
//                           if (!isFilterApplied) {
//                             itemSwatchHtml +=
//                               '<input class="ColorSwatch__Radio" type="radio" ' 
//                               ' name="' + color_name +
//                               '" id="' + color_input_id +
//                               '" value="' + value +
//                               '" data-image-aspect-ratio="1"' +
//                               ' data-variant-price="' + variant_price +
//                               '" data-variant-compare-at-price="' + variant_compare_at_price +
//                               '" data-variant-url="' + Utils.buildProductItemUrl(data) +
//                               '?variant=' + variant.id +
//                               '#Image' + imageInfo.id + '"' +
//                               dataImg + ' aria-hidden="true">';
                          
//                             itemSwatchHtml +=
//                               '<label class="ColorSwatch ColorSwatch--small ' + activeClass + ' " for="' + color_input_id +
//                               '" style="background-color: ' + value.replace(/\s/g, '').toLowerCase() +
//                               '; background-image: url(' + url_color +
//                               ')" title="' + value +
//                               '" data-tooltip="' + value + '"></label>';
//                           }
                          
//                           // CASE 2: Filter is applied → only show if this variant matches filter
//                           else if (isVariantFiltered) {
//                             itemSwatchHtml +=
//                               '<input class="ColorSwatch__Radio" type="radio" ' + checked +
//                               ' name="' + color_name +
//                               '" id="' + color_input_id +
//                               '" value="' + value +
//                               '" data-image-aspect-ratio="1"' +
//                               ' data-variant-price="' + variant_price +
//                               '" data-variant-compare-at-price="' + variant_compare_at_price +
//                               '" data-variant-url="' + Utils.buildProductItemUrl(data) +
//                               '?variant=' + variant.id +
//                               '#Image' + imageInfo.id + '"' +
//                               dataImg + ' aria-hidden="true">';
                          
//                             itemSwatchHtml +=
//                               '<label class="ColorSwatch ColorSwatch--small ' + activeClass + ' " for="' + color_input_id +
//                               '" style="background-color: ' + value.replace(/\s/g, '').toLowerCase() +
//                               '; background-image: url(' + url_color +
//                               ')" title="' + value +
//                               '" data-tooltip="' + value + '"></label>';
//                           }
                          
//                           itemSwatchHtml += '</div>';
//             }
//             i++;
//           }
//         });

//         itemSwatchHtml += '</div>';
//       }
//     });
//   }

//   return itemSwatchHtml;
// }


  // code by Krys Dev
  
	// function buildSwatch(data, indx) {
	// 	var itemSwatchHtml = '';
	// 	if (boostPFSThemeConfig.custom.show_color_swatch) {
	// 	var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;
	// 	data.options_with_values.forEach(function (option, index) {
	// 		var option_name = option.name.toLowerCase();
	// 		if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
	// 		var values = '';
	// 		itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
	// 		var i = 0;
	// 		data.variants.forEach(function (variant) {
	// 			var temp = variant.merged_options.filter(function (obj) {
	// 				obj = obj.toLowerCase();
	// 				if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1 || obj.indexOf('couleur') != -1)
	// 					return obj;
	// 			});
	// 			temp = temp[0].split(':');

	// 			//var value = temp[1].toLowerCase();
 //                var value = temp[1];
	// 			if (values.indexOf(value) == -1) {
	// 				values = values + ',' + value;
	// 				values = values.split(',');
	// 				var size = '200,400,600,700,800,900,1000,1200';
	// 				var supported_sizes = imageSize(size, variant.image);
	// 				var color_image = Utils.optimizeImage(variant.image);
	// 				var name_color = Utils.slugify(value) + '.png';
	// 				var checked = (i == 0) ? 'checked=checked' : '';
	// 				var imageInfo = null;
	// 				var image_aspect_ratio = 1;
	// 				imageInfo = data.images_info.find(function (imageOb) {
	// 					if (imageOb.src == variant.image){
	// 						image_aspect_ratio = imageOb.width / imageOb.height;
	// 					return imageOb;
	// 					}
	// 				});
	// 				if (!imageInfo){
	// 					if (data.images_info.length > 0){
	// 						imageInfo = data.images_info[0];
	// 					} else {
	// 						imageInfo = {
	// 						src: boostPFSConfig.general.no_image_url,
	// 							id: variant.id,
	// 							width: 480,
	// 							height: 480
	// 						}
	// 					}

	// 				}
					// var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
					// var color_input_id = color_name + "-" + values.length;
					// var variant_price = variant.price ? variant.price : 0;
					// var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
					// var url_color = Utils.getFilePath(mySlugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
					// itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
					// itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' +  imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
					// itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
					// itemSwatchHtml += '</div>';
					// i++;
	// 			}
	// 		});
	// 		itemSwatchHtml += '</div>';
	// 		}
	// 	});



          
	// 	}
	// 	return itemSwatchHtml;
	// }
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
					sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var topSortingSelector = jQ(Selector.topSorting);
		topSortingSelector.find('.Popover__Value').click(function(e) {
			FilterApi.setParam('sort', jQ(this).data('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
			jQ('.CollectionToolbar__Item--sort').trigger('click');
		});
	}
	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
		/**
		 *  Call theme function
		 *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
		 *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
		 *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;

		if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
		bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
		bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
		}
		*/

      // custom code 

      // color filter
      selectedColorFilter = BoostPFS.Globals.queryParams["pf_m_::custom::color_filter"] || [];
      // console.log('Selected Filter in afterRender:', selectedColorFilter);

      // aplication filter 
      selectedAppFilter = (
          BoostPFS.Globals.queryParams["pf_m_::custom::application_filter"] || []
        ).map(c => {
          const txt = document.createElement("textarea");
          txt.innerHTML = c;
          return txt.value.trim();
        });
        

		// stock filter
		selectedStockFilter = (
		BoostPFS.Globals.queryParams["pf_m_::custom::limitedstock_filter"] || []
		).map(c => {
		const txt = document.createElement("textarea");
		txt.innerHTML = c;
		return txt.value.trim();
		});

		// ✅ KOI FILTER SELECT HO TO EMPTY SWATCH PRODUCTS HIDE KARO
			setTimeout(function() {
			var anyFilterActive = 
				(BoostPFS.Globals.queryParams["pf_m_::custom::color_filter"] || []).length > 0 ||
				(BoostPFS.Globals.queryParams["pf_m_::custom::application_filter"] || []).length > 0 ||
				(BoostPFS.Globals.queryParams["pf_m_::custom::limitedstock_filter"] || []).length > 0;

			if (anyFilterActive) {
				document.querySelectorAll('.Grid__Cell').forEach(function(cell) {
				var swatchList = cell.querySelector('.ProductItem__ColorSwatchList');
				if (!swatchList || swatchList.children.length === 0) {
					cell.style.display = 'none';
				}
				});
			} else {
				// filter clear ho toh sab wapas dikhao
				document.querySelectorAll('.Grid__Cell').forEach(function(cell) {
				cell.style.display = '';
				});
			}
			}, 600);


		// console.log("Selected Stock Filter:", selectedStockFilter);

        // console.log("Selected Application Filter:", selectedAppFilter);
      
      // const selectedAppFilter = (
      //   BoostPFS.Globals.queryParams["pf_m_::custom::application_filter"] || []
      // ).map(c => {
      //   const txt = document.createElement("textarea");
      //   txt.innerHTML = c;
      //   return txt.value.trim();
      // });
      
      // console.log("Selected Application Filter:", selectedAppFilter);
      // custom code 

		// Fix image not load on Instagram browser - initialize swatch image
		jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function() {
			jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
			jQ(this).addClass('active');
			var parent = jQ(this).parent();
			var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
			var variantInfo = parent.find('input.ColorSwatch__Radio');
			productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
			productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
			productImage.find('img.ProductItem__Image').hide();
			productImage.attr('href', variantInfo.data('variant-url'));
			var variantPrice = '';
			if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')){
				variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
				variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
			} else {
				variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
			}
			jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
		})

		//Change view layout
		var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
		if (desktopView && desktopView != parseInt(boostPFSThemeConfig.custom.desktop_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--' + buildClass());
			jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
		}
		var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
		if (mobileView && mobileView != parseInt(boostPFSThemeConfig.custom.mobile_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/'+ boostPFSThemeConfig.custom.mobile_row + '--phone');
			jQ(Selector.products + ' .Grid__Cell').addClass('1/'+ mobileView + '--phone');
		}
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
		
		var text = (data.total_product > 1) ? "products" : "product";
		jQ('.boost-pfs-filter-total-products').html(data.total_product + ' ' + text);
	};
  

	// Build Default layout
	Filter.prototype.errorFilterCallback = function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};



})(); 



